<div class="title">{{ 'contacts.addContact' | translate }}</div>

<div [alarisLoading]="contactGroupsService.loading$" class="container">
	<alaris-tabs-button
		[formControl]="recipientsType"
		[tabs]="tabs"
		class="selector"
		data-testid="recipientsTypeTabs"
		size="xl"
	>
	</alaris-tabs-button>
	<div class="contacts">
		@switch (_recipientsType) {
			@case (CampaignRecipientsType.GROUP) {
				<alaris-multi-select2
					mode="tag"
					[errors]="errors"
					[displayWith]="displayFnGroups.bind(this)"
					[formControl]="cw.contactGroups"
					[label]="'campaigns.recipientsType.selectGroup' | translate"
					[optionsCount]="(contactGroupsService.list$ | async)?.length || 0"
					[placeholder]="'campaigns.recipientsType.selectGroup' | translate"
					errorMode="touched"
					asterisk="activated"
					data-testid="groupsMultiSelect"
				>
					<alaris-multi-select-filter2 [formControl]="groupsFilter" data-testid="groupsFilter">
					</alaris-multi-select-filter2>
					@for (
						group of contactGroupsService.list$ | async | alarisFilter: groupsMatcher : groupsFilter.value;
						track $index
					) {
						<alaris-multi-options2 [attr.data-testid]="'groupsOption/' + group.name" [value]="group.id">
							{{ group.name | translate }}
						</alaris-multi-options2>
					}
				</alaris-multi-select2>
			}
			@case (CampaignRecipientsType.MANUALLY) {
				<div [alarisLoading]="countriesService.loading$" class="plain-recipients">
					<div class="write-contacts-note">
						<div class="title">{{ 'campaigns.writeContactsNote' | translate }}</div>
						<li>{{ 'campaigns.pastPhoneNote' | translate }}</li>
						<li>{{ 'campaigns.phoneFormatNote' | translate }}</li>
					</div>
					<alaris-select2
						[displayWith]="displayCountryCode.bind(this)"
						[formControl]="cw.contactsPlain.controls.code"
						[label]="'campaigns.recipientsType.countryCode' | translate"
						[placeholder]="'campaigns.recipientsType.selectCountryCode' | translate"
						[stateAddonEnabled]="{ reset: true, state: false }"
						data-testid="codeSelect"
						size="md"
					>
						<alaris-select-filter2 [formControl]="countriesFilter" data-testid="codeFilter"> </alaris-select-filter2>
						@for (
							opt of countriesService.list$ | async | alarisFilter: countryCodeMatcher : countriesFilter.value;
							track $index
						) {
							<alaris-options2 [attr.data-testid]="'codeOptions/' + opt.code" [value]="opt.code">
								( +{{ opt.code }} ) {{ opt.name }}
							</alaris-options2>
						}
					</alaris-select2>
					<alaris-text-area
						[errors]="errors"
						[formControl]="cw.contactsPlain.controls.text"
						[required]="recipientsType.value === CampaignRecipientsType.MANUALLY"
						[rows]="9"
						errorMode="touched"
						asterisk="activated"
						data-testid="manualPhonesTextarea"
					>
						{{
							cw.contactsPlain.controls.code.value
								? ('campaigns.recipientsType.phonesWithCountry' | translate)
								: ('campaigns.recipientsType.phonesExample' | translate)
						}}
					</alaris-text-area>
				</div>
			}
			@case (CampaignRecipientsType.FILE) {
				<div class="write-contacts-note">
					<div class="template">
						{{ 'contacts.import.fileHintPart1' | translate }}
						<alaris-link
							(click)="generateTemplate()"
							[underline]="false"
							data-testid="sampleTemplateLink"
							type="accent"
						>
							{{ 'contacts.import.fileHintPart2' | translate }}
						</alaris-link>
					</div>
					<div class="title">{{ 'campaigns.uploadFileNote' | translate }}</div>
					<li>{{ 'campaigns.fileFormatNote' | translate }}</li>
					<li>{{ 'campaigns.columnFormatNote' | translate }}</li>
					<li>{{ 'campaigns.phoneFormatNote' | translate }}</li>
					<li>{{ 'campaigns.newLineNote' | translate }}</li>
				</div>
				<alaris-file-loader
					class="file-loader"
					(fileListChanges)="addFiles($event)"
					[exportInternally]="true"
					dropText="campaigns.dropContactList"
					[files]="this.cw.contactsFile.value ? [this.cw.contactsFile.value] : []"
					[multiple]="false"
					data-testid="recipientsFile"
				>
				</alaris-file-loader>
			}
		}
	</div>
	<div class="statistics">
		@if (recipientsType.value === CampaignRecipientsType.GROUP && contactGroupValue.length) {
			<app-campaign-statistics-chart
				[labels]="contactGroupLabels"
				[totalRecipients]="cw.totalRecipients()"
				[value]="contactGroupValue"
			>
			</app-campaign-statistics-chart>
		}
		@if (recipientsType.value === CampaignRecipientsType.MANUALLY && cw.totalRecipients()) {
			<app-campaign-statistics-chart
				[labels]="['campaigns.recipientsType.phoneAmount' | translate, 'campaigns.duplicates' | translate]"
				[totalRecipients]="cw.totalRecipients()"
				[value]="manualPhonesValue"
			>
			</app-campaign-statistics-chart>
		}
		@if (recipientsType.value === CampaignRecipientsType.FILE && cw.totalRecipients()) {
			<app-campaign-statistics-chart
				[alarisLoading]="fileLoading$"
				[labels]="[
					'campaigns.recipientsType.fileCorrectRows' | translate,
					'campaigns.recipientsType.fileErrorRows' | translate,
					'campaigns.recipientsType.fileDuplicateRows' | translate,
				]"
				[totalRecipients]="cw.totalRecipients()"
				[value]="fileUploadAnalysis"
			>
			</app-campaign-statistics-chart>
		}
	</div>
</div>
